import { setGetListAdminAction } from '../action';
import { getListAdmin } from '../api/getListAdmin';

const setGetListAdmin = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListAdmin(params);

            if (data.status === 'success') {
                dispatch(setGetListAdminAction(data.data));
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListAdmin
}